import { TIITSignInStore } from './types';

export const IITInitialState: TIITSignInStore = {
  isSigning: false,
  isLoading: false,
  cloudKeyQRVerificationURL: 'https://',
  isCloudKeyQRVerificationModalOpen: false,
  IITHashes: [],
  IITSigns: [],
  isIITSignsLoaded: false,
  isPrivateKeyLoaded: false,
  error: null,
  hasError: false,
  unSavedDocuments: [],
  uploadedDocuments: [],
};
